'use client';

import './credit-card-fields.scss';

import { useCallback, useMemo, useState } from 'react';

// import validator from 'card-validator';

/**
 * Replicating card-validator's card type interface here
 * since Braintree doesn't have great type support for this.
 * @TODO room for improvement here if we need it.
 */
// import validator from 'card-validator';
import {
  CreditCardContext,
  type CreditCardType,
  creditCardValidator as validator,
} from './utils';

/**
 * Provider for all credit card related fields.
 */
export const CreditCardFields: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [card, internalSetCard] = useState<CreditCardType | null>(null);

  /**
   * Helps to normalize the card type names.
   * Eventually might want to move inner logic to a utility function,
   */
  const setCard = useCallback((cardToSet: CreditCardType | null) => {
    const normalizedCard = !cardToSet
      ? null
      : {
          ...cardToSet,
          type: cardToSet.type,
        };

    internalSetCard(normalizedCard);
  }, []);

  const contextData = useMemo(
    () => ({
      card,
      setCard,
      validator,
    }),
    [JSON.stringify(card)],
  );

  return (
    <CreditCardContext.Provider value={contextData}>
      {children}
    </CreditCardContext.Provider>
  );
};
